import script from "./ESGDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ESGDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ESGDashboard.vue?vue&type=style&index=0&id=68fc95c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68fc95c0"]])

export default __exports__